import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Row, Col, Card, Container, Dropdown, Badge } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './AdminPersonalInfo.css';
import Swal from 'sweetalert2';
import Navbar from "../../Pages/Navbar/AdminNavbar";
import BaseUrl from '../../ApiServices/BaseUrl';

const countries = [...new Set([
  'India',
  'Bangladesh',
  'Nepal',
  'Sri Lanka',
  'Pakistan',
  'Philippines',
  'Indonesia',
  'Myanmar',
  'Vietnam',
  'Cambodia',
  'Thailand',
  'Ethiopia',
  'Kenya',
  'Uganda',
  'Tanzania',
  'Rwanda',
  'Ghana',
  'Nigeria',
  'Sierra Leone',
  'Burundi',
  // All other world countries
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia',
  'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Barbados', 'Belarus', 'Belgium',
  'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei',
  'Bulgaria', 'Burkina Faso', 'Cabo Verde', 'Cameroon', 'Canada', 'Central African Republic', 'Chad',
  'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini',
  'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Greece', 'Grenada',
  'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
  'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
  'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali',
  'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia',
  'Montenegro', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Netherlands', 'New Zealand',
  'Nicaragua', 'Niger', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Palau',
  'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Poland', 'Portugal', 'Qatar',
  'Romania', 'Russia', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
  'Spain', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Ukraine', 'United Arab Emirates', 'UAE', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu',
  'Vatican City', 'Venezuela', 'Yemen', 'Zambia', 'Zimbabwe'
])].sort();

const current_countries = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
  'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo (Congo-Brazzaville)', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus',
  'Czech Republic (Czechia)', 'Democratic Republic of the Congo', 'Denmark',
  'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador',
  'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini (Swaziland)', 'Ethiopia',
  'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana',
  'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
  'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland',
  'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati',
  'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia',
  'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
  'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
  'Mozambique', 'Myanmar (Burma)', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia',
  'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea',
  'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
  'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
  'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden',
  'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste',
  'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
  'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates (UAE)', 'UAE', 'United Kingdom (UK)',
  'United States of America (USA)', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City',
  'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

const religions = ['Christian', 'Muslim', 'Hindu', 'Buddhism', 'Sikhism', 'Judaism'];
const maritalStatuses = ['Married', 'Unmarried', 'Divorce', 'Separated'];

const workExperienceOptions = [
  'Fresher',
  ...Array.from({ length: 15 }, (_, i) => `${i + 1} ${i === 0 ? 'year' : 'years'}`),
  'Above 15 years'
];

const allCountryApplyOptions = [
  "Jobs in Afghanistan", "Jobs in Albania", "Jobs in Algeria", "Jobs in Andorra", "Jobs in Angola",
  "Jobs in Antigua and Barbuda", "Jobs in Argentina", "Jobs in Armenia", "Jobs in Australia", "Jobs in Austria",
  "Jobs in Azerbaijan", "Jobs in Bahamas", "Jobs in Bahrain", "Jobs in Bangladesh", "Jobs in Barbados",
  "Jobs in Belarus", "Jobs in Belgium", "Jobs in Belize", "Jobs in Benin", "Jobs in Bhutan",
  "Jobs in Bolivia", "Jobs in Bosnia and Herzegovina", "Jobs in Botswana", "Jobs in Brazil", "Jobs in Brunei",
  "Jobs in Bulgaria", "Jobs in Burkina Faso", "Jobs in Burundi", "Jobs in Cabo Verde", "Jobs in Cambodia",
  "Jobs in Cameroon", "Jobs in Canada", "Jobs in Central African Republic", "Jobs in Chad", "Jobs in Chile",
  "Jobs in China", "Jobs in Colombia", "Jobs in Comoros", "Jobs in Congo", "Jobs in Costa Rica",
  "Jobs in Croatia", "Jobs in Cuba", "Jobs in Cyprus", "Jobs in Czech Republic", "Jobs in Democratic Republic of the Congo",
  "Jobs in Denmark", "Jobs in Djibouti", "Jobs in Dominica", "Jobs in Dominican Republic", "Jobs in East Timor",
  "Jobs in Ecuador", "Jobs in Egypt", "Jobs in El Salvador", "Jobs in Equatorial Guinea", "Jobs in Eritrea",
  "Jobs in Estonia", "Jobs in Eswatini", "Jobs in Ethiopia", "Jobs in Fiji", "Jobs in Finland",
  "Jobs in France", "Jobs in Gabon", "Jobs in Gambia", "Jobs in Georgia", "Jobs in Germany",
  "Jobs in Ghana", "Jobs in Greece", "Jobs in Grenada", "Jobs in Guatemala", "Jobs in Guinea",
  "Jobs in Guinea-Bissau", "Jobs in Guyana", "Jobs in Haiti", "Jobs in Honduras", "Jobs in Hong Kong",
  "Jobs in Hungary", "Jobs in Iceland", "Jobs in India", "Jobs in Indonesia", "Jobs in Iran",
  "Jobs in Iraq", "Jobs in Ireland", "Jobs in Israel", "Jobs in Italy", "Jobs in Ivory Coast",
  "Jobs in Jamaica", "Jobs in Japan", "Jobs in Jordan", "Jobs in Kazakhstan", "Jobs in Kenya",
  "Jobs in Kiribati", "Jobs in Korea, North", "Jobs in Korea, South", "Jobs in Kosovo", "Jobs in Kuwait",
  "Jobs in Kyrgyzstan", "Jobs in Laos", "Jobs in Latvia", "Jobs in Lebanon", "Jobs in Lesotho",
  "Jobs in Liberia", "Jobs in Libya", "Jobs in Liechtenstein", "Jobs in Lithuania", "Jobs in Luxembourg",
  "Jobs in Macau", "Jobs in Madagascar", "Jobs in Malawi", "Jobs in Malaysia", "Jobs in Maldives",
  "Jobs in Mali", "Jobs in Malta", "Jobs in Marshall Islands", "Jobs in Mauritania", "Jobs in Mauritius",
  "Jobs in Mexico", "Jobs in Micronesia", "Jobs in Moldova", "Jobs in Monaco", "Jobs in Mongolia",
  "Jobs in Montenegro", "Jobs in Morocco", "Jobs in Mozambique", "Jobs in Myanmar", "Jobs in Namibia",
  "Jobs in Nauru", "Jobs in Nepal", "Jobs in Netherlands", "Jobs in New Zealand", "Jobs in Nicaragua",
  "Jobs in Niger", "Jobs in Nigeria", "Jobs in North Macedonia", "Jobs in Norway", "Jobs in Oman",
  "Jobs in Pakistan", "Jobs in Palau", "Jobs in Palestine", "Jobs in Panama", "Jobs in Papua New Guinea",
  "Jobs in Paraguay", "Jobs in Peru", "Jobs in Philippines", "Jobs in Poland", "Jobs in Portugal",
  "Jobs in Qatar", "Jobs in Romania", "Jobs in Russia", "Jobs in Rwanda", "Jobs in Saint Kitts and Nevis",
  "Jobs in Saint Lucia", "Jobs in Saint Vincent and the Grenadines", "Jobs in Samoa", "Jobs in San Marino", "Jobs in Sao Tome and Principe",
  "Jobs in Saudi Arabia", "Jobs in Senegal", "Jobs in Serbia", "Jobs in Seychelles", "Jobs in Sierra Leone",
  "Jobs in Singapore", "Jobs in Slovakia", "Jobs in Slovenia", "Jobs in Solomon Islands", "Jobs in Somalia",
  "Jobs in South Africa", "Jobs in South Sudan", "Jobs in Spain", "Jobs in Sri Lanka", "Jobs in Sudan",
  "Jobs in Suriname", "Jobs in Sweden", "Jobs in Switzerland", "Jobs in Syria", "Jobs in Taiwan",
  "Jobs in Tajikistan", "Jobs in Tanzania", "Jobs in Thailand", "Jobs in Togo", "Jobs in Tonga",
  "Jobs in Trinidad and Tobago", "Jobs in Tunisia", "Jobs in Turkey", "Jobs in Turkmenistan", "Jobs in Tuvalu",
  "Jobs in Uganda", "Jobs in Ukraine", "Jobs in United Arab Emirates (UAE)", "Jobs in United Kingdom (UK)", "Jobs in United States (USA)",
  "Jobs in Uruguay", "Jobs in Uzbekistan", "Jobs in Vanuatu", "Jobs in Vatican City", "Jobs in Venezuela",
  "Jobs in Vietnam", "Jobs in Yemen", "Jobs in Zambia", "Jobs in Zimbabwe", "Jobs Worldwide (Any)"
];

const priorityCountryApplyOptions = [
  "Gulf Country & Europe",
  "Gulf Country",
  "Europe Country",
  "Any Country",
  "Job in any Gulf country",
  "Job in any European country",
  "Jobs in Saudi Arabia",
  "Jobs in Dubai (UAE)",
  "Jobs in Qatar",
  "Jobs in Kuwait",
  "Jobs in Oman",
  "Jobs in Bahrain",
  "Jobs in Singapore",
  "Jobs in Brunei",
  "Jobs in South Korea",
  "Jobs in Japan",
  "Jobs in Croatia",
  "Jobs in Belgium",
  "Jobs in Poland",
  "Jobs in Yemen",
  "Jobs in Iraq",
  "Jobs in Iran",
  "Jobs in Jordan",
  "Jobs in Lebanon",
  "Jobs in Syria",
  "Jobs in Israel",
  "Jobs in Palestine"
];

const countryApplyOptions = [
  ...priorityCountryApplyOptions,
  ...allCountryApplyOptions
    .filter((country) => !priorityCountryApplyOptions.includes(country))
    .filter((country) => country !== "Jobs in Korea, South")
];


const AdminPersonalInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get userId from navigation state
  const { userId, candidateData } = location.state || {};

  const [formData, setFormData] = useState({
    user_id: userId || '',
    first_name: '',
    last_name: '',
    age: '',
    gender: '',
    marital_status: '',
    nationality: '',
    religion: '',
    current_country: '',
    total_work_experience: '',
    country_apply_for_job: 'Gulf Country & Europe'
  });

  const [originalData, setOriginalData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [searchTerms, setSearchTerms] = useState({
    nationality: '',
    current_country: '',
    religion: '',
    marital_status: '',
    total_work_experience: '',
    age: ''
  });

  // Refs for input fields
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const ageRef = useRef(null);
  const genderRef = useRef(null);
  const maritalStatusRef = useRef(null);
  const nationalityRef = useRef(null);
  const religionRef = useRef(null);
  const currentCountryRef = useRef(null);
  const workExperienceRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redirect if no userId is provided
  useEffect(() => {
    if (!userId) {
      Swal.fire({
        title: 'Error!',
        text: 'No candidate selected. Please select a candidate from Manage Employees.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      }).then(() => {
        navigate('/manageemployee');
      });
    }
  }, [userId, navigate]);

  // Fetch job seeker data based on userId from state
  useEffect(() => {
    const fetchJobSeekerData = async () => {
      if (!userId) return;

      setIsFetching(true);
      try {
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);

        if (response.ok) {
          const data = await response.json();
          if (data) {
            setFormData(prev => ({
              ...prev,
              ...data,
              user_id: userId, // Ensure user_id is set correctly
              first_name: data.first_name || '',
              last_name: data.last_name || ''
            }));
            setOriginalData(data);
            setIsSaved(true);
          }
        } else if (response.status === 404) {
          // No existing data - initialize with candidateData if available
          if (candidateData) {
            setFormData(prev => ({
              ...prev,
              first_name: candidateData.first_name || '',
              last_name: candidateData.last_name || '',
              age: candidateData.age || '',
              gender: candidateData.gender || '',
              marital_status: candidateData.marital_status || '',
              nationality: candidateData.nationality || '',
              religion: candidateData.religion || '',
              current_country: candidateData.current_country || '',
              total_work_experience: candidateData.total_work_experience || '',
            }));
          }
          setIsSaved(false);
        } else {
          throw new Error('Failed to fetch job seeker data');
        }
      } catch (err) {
        console.error('Error fetching job seeker data:', err);
        setError(err.message);

        // If error occurs but we have candidateData, use that
        if (candidateData) {
          setFormData(prev => ({
            ...prev,
            first_name: candidateData.first_name || '',
            last_name: candidateData.last_name || '',
            age: candidateData.age || '',
            gender: candidateData.gender || '',
            marital_status: candidateData.marital_status || '',
            nationality: candidateData.nationality || '',
            religion: candidateData.religion || '',
            current_country: candidateData.current_country || '',
            total_work_experience: candidateData.total_work_experience || '',
          }));
        }
      } finally {
        setIsFetching(false);
      }
    };

    fetchJobSeekerData();
  }, [userId, candidateData]);

  const handleSelect = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setError(null);
    setIsSaved(false);
    setSearchTerms(prev => ({ ...prev, [field]: '' }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError(null);
    setIsSaved(false);
  };

  const handleSearchChange = (field, value) => {
    setSearchTerms(prev => ({ ...prev, [field]: value }));
  };

  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const saveData = async () => {
    setIsLoading(true);
    setError(null);

    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      // Remove driving_country_experience if it exists in formData
      const { driving_country_experience, user_apply_for, ...dataToSend } = formData;

      // Ensure user_id is set
      dataToSend.user_id = userId;

      // Ensure all array fields are stringified before sending to prevent backend/MySQL syntax errors
      Object.keys(dataToSend).forEach(key => {
        if (Array.isArray(dataToSend[key])) {
          dataToSend[key] = JSON.stringify(dataToSend[key]);
        }
      });

      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to save data');
      }

      await Swal.fire({
        title: 'Success!',
        text: 'Candidate personal information has been updated successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setIsSaved(true);
      return result;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const focusOnField = (fieldName) => {
    setTimeout(() => {
      let element = null;

      switch (fieldName) {
        case 'first_name':
          element = firstNameRef.current;
          break;
        case 'last_name':
          element = lastNameRef.current;
          break;
        case 'age':
          element = ageRef.current;
          break;
        case 'gender':
          element = genderRef.current;
          break;
        case 'marital_status':
          element = maritalStatusRef.current;
          break;
        case 'nationality':
          element = nationalityRef.current;
          break;
        case 'religion':
          element = religionRef.current;
          break;
        case 'current_country':
          element = currentCountryRef.current;
          break;
        case 'total_work_experience':
          element = workExperienceRef.current;
          break;
        default:
          break;
      }

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (['first_name', 'last_name', 'age'].includes(fieldName)) {
          setTimeout(() => {
            element.focus();
            if (document.activeElement !== element) {
              element.focus();
            }
          }, 300);
        } else if (['nationality', 'current_country', 'total_work_experience'].includes(fieldName)) {
          setTimeout(() => {
            const dropdownToggle = element.querySelector('.dropdown-toggle');
            if (dropdownToggle) {
              dropdownToggle.click();
            }
          }, 300);
        } else {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 300);
        }
      }
    }, 100);
  };

  const validateFormData = async () => {
    const requiredFields = [
      'age', 'gender', 'first_name', 'last_name', 'marital_status',
      'nationality', 'religion', 'current_country'
    ];

    const missingFields = requiredFields.filter(field => !formData[field]);

    if (missingFields.length > 0) {
      const fieldNames = {
        age: 'Age',
        gender: 'Gender',
        first_name: 'First Name',
        last_name: 'Last Name',
        marital_status: 'Marital Status',
        nationality: 'Nationality',
        religion: 'Religion',
        current_country: 'Current Country',
        total_work_experience: 'Total Work Experience'
      };

      const missingFieldNames = missingFields.map(field => fieldNames[field] || field);

      const result = await Swal.fire({
        title: 'Missing Information!',
        html: `Please fill in all required fields:<br><br>${missingFieldNames.join('<br>')}`,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        const firstMissingField = missingFields[0];
        focusOnField(firstMissingField);
      }

      return false;
    }

    if (formData.age && (formData.age < 18 || formData.age > 80)) {
      const result = await Swal.fire({
        title: 'Invalid Age!',
        text: 'Age must be between 18 and 80',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        focusOnField('age');
      }
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleSaveAndContinue = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
      window.scrollTo(0, 0);
      navigate('/admincontactdetails', {
        state: {
          userId,
          current_country: formData.current_country,
          candidateName: `${formData.first_name} ${formData.last_name}`
        }
      });
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleBack = () => {
    navigate('/manageemployee');
  };

  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = ''
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    const dropdownRef = useRef(null);

    React.useEffect(() => {
      switch (field) {
        case 'age':
          if (dropdownRef.current) ageRef.current = dropdownRef.current;
          break;
        case 'nationality':
          if (dropdownRef.current) nationalityRef.current = dropdownRef.current;
          break;
        case 'current_country':
          if (dropdownRef.current) currentCountryRef.current = dropdownRef.current;
          break;
        case 'total_work_experience':
          if (dropdownRef.current) workExperienceRef.current = dropdownRef.current;
          break;
        default:
          break;
      }
    }, [field]);

    return (
      <div ref={dropdownRef}>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            {selectedValue || `${title}${required ? ' *' : ''}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValue === option}
                    onClick={() => {

                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  if (isFetching) {
    return (
      <>
        <Navbar />
        <div className="skills-wrapper" style={{ marginTop: "84px" }}>
          <Container className="mt-4 px-4 pb-5 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading candidate information...</p>
          </Container>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="skills-wrapper" style={{ marginTop: "84px" }}>
        <Container className="mt-4 px-4 pb-2">
          {/* Admin Header */}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
            <div className="d-flex align-items-center gap-2">
              <Button
                variant="outline-secondary"
                onClick={handleBack}
                className="me-2 back-btn-mobile"
              >
                <i className="bi bi-arrow-left me-1"></i>
                Back
              </Button>
              {/* <h3 className="mb-0 text-primary editing-candidate-title text-truncate">
                Editing Candidate: {formData.first_name} {formData.last_name}
              </h3> */}
            </div>
            <Badge bg="info" className="p-2 d-none">
              User ID: {userId}
            </Badge>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <Card className="shadow border-0 personal-info-card">
            <Card.Header className="personal-info-header">
              <div className="d-flex align-items-center justify-content-center">
                <i className="bi bi-person-vcard me-3 fs-2" style={{ color: "white" }}></i>
                <h2 className="m-0 text-white">
                  Edit Personal Information - Admin
                </h2>
              </div>
            </Card.Header>
            <Card.Body className='personalinfo-cardheight'>
              <Form>
                <Row className="g-3 mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <h4 className="fw-semibold text-dark fields-headingfont">First Name <span className="text-danger">*</span></h4>
                      <Form.Control
                        ref={firstNameRef}
                        style={{ backgroundColor: "#aec9f3" }}
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        placeholder="First Name"
                        className="language-select-personalinfo"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <h4 className="fw-semibold text-dark fields-headingfont">Last Name <span className="text-danger">*</span></h4>
                      <Form.Control
                        ref={lastNameRef}
                        style={{ backgroundColor: "#aec9f3" }}
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChange}
                        placeholder="Last Name"
                        className="language-select-personalinfo"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <h4 className="fw-semibold text-dark fields-headingfont">Age <span className="text-danger">*</span></h4>
                  <CustomDropdown
                    title="Select your Age"
                    field="age"
                    options={Array.from({ length: 63 }, (_, i) => (i + 18).toString())}
                    selectedValue={formData.age}
                    onSelect={handleSelect}
                    required
                  />
                </Form.Group>

                <div ref={genderRef}>
                  <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Gender <span className="text-danger">*</span></h4>
                  <Row className="g-2 mb-3">
                    {['Male', 'Female'].map(gender => (
                      <Col xs={6} key={gender}>
                        <Button
                          type="button"
                          className={`language-btn-personalnfo w-100 ${formData.gender === gender ? 'selected' : ''}`}
                          onClick={() => handleSelect('gender', gender)}
                        >
                          {gender}
                          {formData.gender === gender && (
                            <span className="ms-1">✓</span>
                          )}
                        </Button>
                      </Col>
                    ))}
                  </Row>
                </div>

                <div ref={maritalStatusRef}>
                  <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Marital Status <span className="text-danger">*</span></h4>
                  <Row className="g-3 mb-3">
                    {maritalStatuses.map(status => (
                      <Col xs={6} lg={3} key={status}>
                        <Button
                          type="button"
                          className={`language-btn-personalnfo w-100 ${formData.marital_status === status ? 'selected' : ''}`}
                          onClick={() => handleSelect('marital_status', status)}
                        >
                          {status}
                          {formData.marital_status === status && (
                            <span className="ms-2">✓</span>
                          )}
                        </Button>
                      </Col>
                    ))}
                  </Row>
                </div>

                <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Nationality <span className="text-danger">*</span></h4>

                {/* Four nationality buttons for top countries */}
                <div className="nationality-buttons-container mb-3">
                  <div className="row g-2">
                    <div className="col-6 col-lg-3 mb-2">
                      <button
                        type="button"
                        className={`nationality-button w-100 ${formData.nationality === 'Philippines' ? 'selected' : ''}`}
                        onClick={() => handleSelect('nationality', 'Philippines')}
                      >
                        Philippines
                        {formData.nationality === 'Philippines' && (
                          <span className="ms-2">✓</span>
                        )}
                      </button>
                    </div>
                    <div className="col-6 col-lg-3 mb-2">
                      <button
                        type="button"
                        className={`nationality-button w-100 ${formData.nationality === 'Indonesia' ? 'selected' : ''}`}
                        onClick={() => handleSelect('nationality', 'Indonesia')}
                      >
                        Indonesia
                        {formData.nationality === 'Indonesia' && (
                          <span className="ms-2">✓</span>
                        )}
                      </button>
                    </div>
                    <div className="col-6 col-lg-3 mb-2">
                      <button
                        type="button"
                        className={`nationality-button w-100 ${formData.nationality === 'Sri Lanka' ? 'selected' : ''}`}
                        onClick={() => handleSelect('nationality', 'Sri Lanka')}
                      >
                        Sri Lanka
                        {formData.nationality === 'Sri Lanka' && (
                          <span className="ms-2">✓</span>
                        )}
                      </button>
                    </div>
                    <div className="col-6 col-lg-3 mb-2">
                      <button
                        type="button"
                        className={`nationality-button w-100 ${formData.nationality === 'India' ? 'selected' : ''}`}
                        onClick={() => handleSelect('nationality', 'India')}
                      >
                        India
                        {formData.nationality === 'India' && (
                          <span className="ms-2">✓</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Dropdown for all nationalities */}
                <CustomDropdown
                  title="Select Other Nationality"
                  field="nationality"
                  options={countries}
                  selectedValue={formData.nationality}
                  onSelect={handleSelect}
                  required
                  menuClassName="personalinfo-nationality-menu"
                />

                <div ref={religionRef}>
                  <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Religion <span className="text-danger">*</span></h4>

                  {/* Two main religion buttons */}
                  <div className="nationality-buttons-container mb-3">
                    <Row className="g-2">
                      {['Christian', 'Muslim'].map(religion => (
                        <Col xs={6} key={religion}>
                          <button
                            type="button"
                            className={`nationality-button w-100 ${formData.religion === religion ? 'selected' : ''}`}
                            onClick={() => handleSelect('religion', religion)}
                          >
                            {religion}
                            {formData.religion === religion && (
                              <span className="ms-2">✓</span>
                            )}
                          </button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  {/* Dropdown for all religions */}
                  <CustomDropdown
                    title="Select Other Religion"
                    field="religion"
                    options={religions}
                    selectedValue={formData.religion}
                    onSelect={handleSelect}
                    required
                    menuClassName="personalinfo-nationality-menu"
                  />
                </div>

                <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Where do you live now (current country) <span className="text-danger">*</span></h4>
                <CustomDropdown
                  title="Select your current country"
                  field="current_country"
                  options={current_countries}
                  selectedValue={formData.current_country}
                  onSelect={handleSelect}
                  required
                  menuClassName="personalinfo-nationality-menu"
                />

                <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Total Work Experience</h4>
                <CustomDropdown
                  title="Select Total Experience"
                  field="total_work_experience"
                  options={workExperienceOptions}
                  selectedValue={formData.total_work_experience}
                  onSelect={handleSelect}
                  required={false}
                  menuClassName="personalinfo-nationality-menu"
                />

                <Form.Group className="mb-3">
                  <h4 className="mb-2 fw-semibold text-dark fields-headingfont">Country to Apply for Job</h4>
                  <CustomDropdown
                    title="Select Country to Apply for Job"
                    field="country_apply_for_job"
                    options={countryApplyOptions}
                    selectedValue={formData.country_apply_for_job}
                    onSelect={handleSelect}
                    menuClassName="personalinfo-nationality-menu"
                  />
                </Form.Group>

                <div className="additional-section mb-1" style={{ marginTop: '10px', padding: '0.5px' }}>
                  <div className="d-flex justify-content-between gap-2" style={{ width: "100%" }}>
                    <button
                      className="nav-btn flex-fill"
                      style={{ flex: 1 }}
                      onClick={handleBack}
                      type="button"
                    >
                      Back
                    </button>

                    <button
                      className="nav-btn flex-fill"
                      style={{ flex: 1 }}
                      onClick={handleSaveAndContinue}
                      disabled={isLoading}
                      type="button"
                    >
                      {isLoading ? 'Saving...' : 'Next'}
                    </button>
                  </div>
                </div>

              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default AdminPersonalInfo;
